import React from 'react';
import { motion } from 'framer-motion';
const painPoints = ['Querés cocinar algo rico pero el miedo a la glucosa te frena antes de empezar.', 'Te gustaría volver a comer pan pero cada receta "saludable" que probás termina en decepción.', 'Mirás recetas sin gluten en Instagram y pensás "yo jamás podría lograr eso".', 'Gastás en ingredientes caros, seguís el paso a paso al pie de la letra y el resultado igual no sirve.', 'Terminás cada semana prometiéndote que "la próxima sí vas a intentarlo de nuevo".'];
export function PainBlock() {
  return <section className="py-20 sm:py-24 px-4 bg-brand-base border-t border-brand-gold/15 relative overflow-hidden" data-id="element-202">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-203"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-brand-gold/10 blur-[120px] rounded-full pointer-events-none" data-id="element-204"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10" data-id="element-206">
          <h2 className="font-display font-extrabold text-brand-gold mb-6 text-[26px] sm:text-[40px] text-center mx-auto max-w-[20ch] tracking-tight glow-gold" style={{
          lineHeight: 1.15
        }} data-id="element-207">
            ❌ ¿Cuántos domingos más vas a terminar así?
          </h2>
          <p className="text-2xl sm:text-3xl font-bold text-brand-cream" data-id="element-208">
            No es falta de ganas.
          </p>
          <p className="text-2xl sm:text-3xl font-bold text-brand-gold mt-1 glow-gold" data-id="element-209">
            Es falta de un sistema.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-ink/80 backdrop-blur-sm border border-brand-gold/25 p-6 sm:p-10 rounded-3xl" style={{
        boxShadow: '0 30px 60px -20px rgba(0,0,0,0.6), inset 0 1px 0 rgba(212, 168, 67, 0.12)'
      }} data-id="element-210">
          <p className="font-bold text-brand-gold uppercase tracking-[0.18em] text-xs sm:text-sm mb-7 text-center glow-gold" data-id="element-211">
            ❌ Lo que estás viviendo ahora mismo
          </p>

          <ul className="space-y-5 mb-8" data-id="element-212">
            {painPoints.map((point, i) => <li key={i} className="flex items-start gap-4 text-left" data-id="element-213">
                <span className="text-brand-gold shrink-0 mt-0.5 font-bold text-lg leading-none" data-id="element-214">
                  →
                </span>
                <span className="text-brand-cream/90 font-medium leading-relaxed text-sm sm:text-base" data-id="element-215">
                  {point}
                </span>
              </li>)}
          </ul>

          <div className="pt-6 border-t border-brand-gold/20" data-id="element-216">
            <p className="sm:text-2xl font-display font-bold text-[18px] text-brand-gold glow-gold italic" data-id="element-217">
              ¿Y si esta fuera la última vez que pasó eso?
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}